module.exports = __webpack_public_path__ + "static/ItemDetails-33ba7d790fe243c2f133b2f216800b04.png";